import React from 'react';
import cn from 'classnames';
import ScorecardQuestionRow from 'components/pure/scorecards/ScorecardQuestionRow';
import {ScorecardHeader} from 'components/pure/scorecards/ScorecardHeader';
import 'styles/ScorecardQuestionnaireGrid.styl';

/**
 * <ScorecardQuestionnaireGrid /> renders a grid of questions and answer choices for a given
 * `Scorecard` object
 */
export default class ScorecardQuestionnaireGrid extends React.Component {
  getReasonSchemeForQuestion(question, reasonSchemes) {
    if (question.cardReasonSchemeId && reasonSchemes) {
      return reasonSchemes.find(scheme => scheme.id === question.cardReasonSchemeId);
    } else {
      return null;
    }
  }

  render() {
    const {
      scorecard,
      reasonSchemes,
      answers,
      comments,
      reasons,
      labels,
      onAddComment,
      onReasonChange,
      onRemoveComment,
      onAddAnswer,
      onRemoveAnswer,
    } = this.props;

    const {questions, scoringScheme} = scorecard;

    const labelScheme = labels.find(l => l.scoringScheme === scoringScheme);

    return (
      <div className={cn('questionnaire-grid', {'new-call-card': this.props.newCallCard})}>
        <div className="row header-row">
          <div className="left">
            <span>Questions:</span>
          </div>
          <ScorecardHeader
            labelScheme={labelScheme}
            scoringScheme={scoringScheme}
            extraWide={!!labelScheme && !labelScheme.default}
          />
        </div>
        {questions.map((question, index) => (
          <ScorecardQuestionRow
            question={question}
            index={index}
            key={index}
            scoringScheme={scoringScheme}
            reasonScheme={this.getReasonSchemeForQuestion(question, reasonSchemes)}
            extraWide={!!labelScheme && !labelScheme.default}
            onAddComment={onAddComment}
            onReasonChange={onReasonChange}
            onRemoveComment={onRemoveComment}
            onAddAnswer={onAddAnswer}
            onRemoveAnswer={onRemoveAnswer}
            answer={answers && answers.get(question.id)}
            comment={comments && comments.get(question.id)}
            reason={reasons && reasons.get(question.id)}
          />
        ))}
      </div>
    );
  }
}
